export const Validator = {
  MDYYYY_REGEXP: /^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/,

  ISO_8601_REGEXP: /^(\d{4})-([01]\d)-([0-3]\d)T([0-2]\d):([0-5]\d):([0-5]\d)\.(\d{3})Z$/,

  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value as string)) && isFinite(value as number);
  },

  isIdentifier(value: string | number) {
    // PRM ID, PIDM, student ID or employee ID (eg 1, 12345, 987654321, 123456789)
    // or program or college code (eg GANT, GS, HACS)
    // or login ID (eg mylogin01)
    // or active directory name (eg GS-US-IT)
    return value && /^([0-9]{1,9}|[A-Z]{2,4}|[a-z][a-z0-9]{1,11}|[A-Z][A-Z0-9-]{1,50}[A-Z])$/g.test(value.toString());
  },

  isDateObject(value: any) {
    return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
  },

  isDate(value: string | Date, regExp?: RegExp): boolean {
    if (!value) {
      return false;
    }

    if (this.isDateObject(value)) {
      return true;
    }

    const isIso8601 = this.ISO_8601_REGEXP.test(value as string);
    const matches = regExp ?
      regExp.exec(value as string) :
      ( isIso8601 ? this.ISO_8601_REGEXP.exec(value as string) : this.MDYYYY_REGEXP.exec(value as string) );

    if (matches == null || matches.length < 3) {
      return false;
    }

    const year = parseInt(isIso8601 ? matches[1] : matches[3], 10);
    const month = parseInt(isIso8601 ? matches[2] : matches[1], 10) - 1;
    const day = parseInt(isIso8601 ? matches[3] : matches[2], 10);

    const composedDate = new Date(year, month, day);

    return composedDate.getDate() === day && composedDate.getMonth() === month && composedDate.getFullYear() === year;
  }
};



// WEBPACK FOOTER //
// ./src/gs-core/common/util/validator.ts